var _themes;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import styled, { css, keyframes } from 'styled-components';
import ControlButton from '../ControlButton/ControlButton';
import tscStyles from '../constants/TscStyles';
import { Close16x16 } from '../constants/Glyphs';
import TscThemeName from '../constants/TscThemeName';
import FocusLock from 'react-focus-lock';
import Spinner from '../Spinner';
import { triggerScreenReader } from '../utils/aria-helper';
import { getClassName } from '../utils/get-class-name';
import TscButtonType from '../constants/TscButtonType';
var structure = {
  headerHeight: '3rem',
  width: '28rem',
  borderRadius: tscStyles.border.radius.large
};
var themes = (_themes = {}, _defineProperty(_themes, TscThemeName.dawn, {
  window: {
    background: tscStyles.color.ui.dawn.light,
    color: tscStyles.color.text.mediumDark
  },
  header: {
    background: tscStyles.color.ui.dawn.lightMedium,
    color: tscStyles.color.text.mediumDark,
    borderColor: tscStyles.color.ui.dawn.mediumDark
  }
}), _defineProperty(_themes, TscThemeName.dusk, {
  window: {
    background: tscStyles.color.ui.dusk.medium,
    color: tscStyles.color.text.light
  },
  header: {
    background: tscStyles.color.ui.dusk.mediumDark,
    color: tscStyles.color.text.light,
    borderColor: tscStyles.color.ui.dusk.dark
  }
}), _themes);
var flyinAnimation = keyframes(["0%{opacity:0;transform:translateY(-25%)}100%{opacity:1;:translateY(0)}"]);
var fadein = keyframes(["from{opacity:0;}to{opacity:1;}"]);
var loadingFadeIn = keyframes(["from{opacity:0;}to{opacity:.9;}"]);
var Container = styled.div.attrs(function (props) {
  return props.testId ? {
    'data-test-id': props.testId
  } : {};
}).withConfig({
  displayName: "BasicModal__Container"
})(["visibility:", ";position:fixed;display:block;top:0;right:0;bottom:0;left:0;color:", ";z-index:", ";text-align:center;overflow-y:auto;opacity:", ";background:rgba(99,106,112,0.5);animation:", " 300ms ease;animation-fill-mode:forwards;.focus-guard{position:absolute;top:0;left:0;right:0;}"], function (props) {
  return props.visible ? 'visible' : 'hidden';
}, tscStyles.color.text.mediumDark, function (props) {
  return props.zIndex;
}, function (props) {
  return props.visible ? '1' : '0';
}, fadein);
var Modal = styled.div.withConfig({
  displayName: "BasicModal__Modal"
})(["width:", ";height:", ";max-width:", ";margin-top:", ";margin-right:auto;margin-bottom:5vh;margin-left:auto;background:", ";color:", ";border-radius:", ";box-shadow:0 0 1rem rgba(0,0,0,.2);animation:", ";position:relative;"], function (props) {
  return props.width;
}, function (props) {
  return props.height;
}, function (props) {
  return props.containToViewport ? '90%' : 'none';
}, function (props) {
  return props.offsetTop || '0';
}, function (props) {
  return themes[props.themeName].window.background;
}, function (props) {
  return themes[props.themeName].window.color;
}, structure.borderRadius, function (props) {
  return props.visible && css(["", " 300ms  ease;"], flyinAnimation);
});
var Header = styled.div.withConfig({
  displayName: "BasicModal__Header"
})(["padding:0 0.5rem 0 1rem;height:", ";display:flex;align-items:center;justify-content:space-between;color:", ";background:", ";border-bottom:1px solid;border-color:", ";flex-shrink:0;border-radius:", " ", " 0 0;z-index:", ";"], structure.headerHeight, function (props) {
  return themes[props.themeName].header.color;
}, function (props) {
  return themes[props.themeName].header.background;
}, function (props) {
  return themes[props.themeName].header.borderColor;
}, structure.borderRadius, structure.borderRadius, function (props) {
  return props.zIndex;
});
var EmptyHeader = styled.div.withConfig({
  displayName: "BasicModal__EmptyHeader"
})(["padding:.5rem .5rem .25rem .25rem;text-align:right;position:absolute;top:0;right:0;z-index:", ";"], function (props) {
  return props.zIndex;
});
var Body = styled.div.withConfig({
  displayName: "BasicModal__Body"
})(["line-height:1.4;position:relative;"]);
var Title = styled.h2.withConfig({
  displayName: "BasicModal__Title"
})(["padding:0;margin:0;font-size:1.125rem;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:600;"]);
var LoadingSpinner = styled.div.withConfig({
  displayName: "BasicModal__LoadingSpinner"
})(["position:absolute;display:flex;align-items:center;top:0;bottom:0;left:0;right:0;z-index:3;opacity:.9;border-radius:", ";border-top-left-radius:", ";border-top-right-radius:", ";background:", ";animation:", " 500ms ease forwards;"], structure.borderRadius, function (props) {
  return props.headerVisible ? '0' : structure.borderRadius;
}, function (props) {
  return props.headerVisible ? '0' : structure.borderRadius;
}, function (props) {
  return props.themeName === TscThemeName.dawn ? tscStyles.color.ui.dawn.lightMedium : tscStyles.color.ui.dusk.dark;
}, loadingFadeIn);

var stopPropagation = function stopPropagation(e) {
  e.stopPropagation();
};

var defaultProps = {
  closeContent: 'Close',
  containToViewport: true,
  enableFocusTrap: true,
  headerVisible: true,
  height: 'auto',
  isLoading: false,
  offsetTop: '10vh',
  themeName: TscThemeName.dawn,
  title: 'Modal Title',
  visible: true,
  width: structure.width,
  zIndex: 10
};

var BasicModal = function BasicModal(props) {
  var _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps), props),
      children = _defaultProps$props.children,
      className = _defaultProps$props.className,
      closeContent = _defaultProps$props.closeContent,
      containToViewport = _defaultProps$props.containToViewport,
      enableFocusTrap = _defaultProps$props.enableFocusTrap,
      headerVisible = _defaultProps$props.headerVisible,
      height = _defaultProps$props.height,
      isLoading = _defaultProps$props.isLoading,
      offsetTop = _defaultProps$props.offsetTop,
      onClose = _defaultProps$props.onClose,
      testId = _defaultProps$props.testId,
      themeName = _defaultProps$props.themeName,
      title = _defaultProps$props.title,
      visible = _defaultProps$props.visible,
      width = _defaultProps$props.width,
      zIndex = _defaultProps$props.zIndex;

  var clickStartedInContainer = React.useRef(false);
  React.useEffect(function () {
    var modalOpenedEvent = new Event(tscStyles.events.modalOpenedOnPage);
    window.dispatchEvent(modalOpenedEvent);
    triggerScreenReader("".concat(title, " modal has been opened"));
    return function () {
      triggerScreenReader("".concat(title, " modal has been closed"));
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // on mount and unmount only

  var resetClickStartedInContainerValue = React.useCallback(function () {
    clickStartedInContainer.current = false;
  }, []);
  var onContainerMouseDown = React.useCallback(function (e) {
    var _e$target;

    clickStartedInContainer.current = true;
    (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.addEventListener('scroll', resetClickStartedInContainerValue);
  }, [resetClickStartedInContainerValue]);
  var onContainerMouseUp = React.useCallback(function (e) {
    var _e$target2;

    (_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : _e$target2.removeEventListener('scroll', resetClickStartedInContainerValue);

    if (clickStartedInContainer.current && onClose) {
      onClose(e);
    }

    resetClickStartedInContainerValue();
  }, [resetClickStartedInContainerValue, onClose]);
  var focusTrapActive = enableFocusTrap && visible;
  var HeaderElement = null;

  if (headerVisible) {
    HeaderElement = _jsxs(Header, {
      className: getClassName(className, 'header'),
      themeName: themeName,
      zIndex: zIndex,
      children: [_jsx(Title, {
        className: getClassName(className, 'title'),
        children: title
      }), onClose && _jsx(ControlButton, {
        className: getClassName(className, 'close'),
        buttonType: TscButtonType.tertiary,
        themeName: themeName,
        title: closeContent,
        glyph: _jsx(Close16x16, {}),
        testId: testId ? "".concat(testId, "-close-button") : '',
        onClick: onClose
      })]
    });
  } else if (onClose) {
    HeaderElement = _jsx(EmptyHeader, {
      className: getClassName(className, 'empty-header'),
      zIndex: zIndex,
      children: _jsx(ControlButton, {
        className: getClassName(className, 'close'),
        buttonType: TscButtonType.tertiary,
        themeName: themeName,
        title: closeContent,
        glyph: _jsx(Close16x16, {}),
        testId: testId ? "".concat(testId, "-close-button") : '',
        onClick: onClose
      })
    });
  }

  return _jsx(Container, {
    className: getClassName(className, null, 'container'),
    visible: visible,
    testId: testId,
    zIndex: zIndex,
    onMouseDown: onContainerMouseDown,
    onMouseUp: onContainerMouseUp,
    children: _jsx(FocusLock, {
      className: getClassName(className, 'focus-lock', 'focus-guard'),
      disabled: !focusTrapActive,
      children: _jsxs(Modal, {
        className: getClassName(className, 'modal'),
        themeName: themeName,
        visible: visible,
        offsetTop: offsetTop,
        width: width,
        height: height,
        containToViewport: containToViewport,
        onClick: stopPropagation,
        onMouseDown: stopPropagation,
        onMouseUp: stopPropagation,
        children: [HeaderElement, _jsxs(Body, {
          className: getClassName(className, 'body'),
          children: [children, isLoading && _jsx(LoadingSpinner, {
            className: getClassName(className, 'loading-spinner'),
            headerVisible: headerVisible,
            themeName: themeName,
            children: _jsx(Spinner, {
              className: className,
              themeName: themeName
            })
          })]
        })]
      })
    })
  });
};

BasicModal.defaultProps = defaultProps;
var BasicModalTest = {
  Container: Container,
  Modal: Modal,
  Header: Header,
  EmptyHeader: EmptyHeader,
  Body: Body,
  Title: Title,
  LoadingSpinner: LoadingSpinner
};
export { BasicModal, BasicModalTest };
export default BasicModal;